<template>
  <v-data-table
    :headers="headers"
    :items="historicoSelic"
    :items-per-page="15"
    class="elevation-1"
    :custom-sort="ordenaPorData"
    :sort-by="['dataFormatada']"
    :sort-desc="['true']"
    :footer-props="{
      itemsPerPageAllText: 'Todos',
      itemsPerPageText: 'Itens por página'
    }"
  ></v-data-table>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      headers: [
        { text: "Data", value: "dataFormatada", sortable: false },
        { text: "Valor (% a.a.)", value: "valor", sortable: false }
      ],
      historicoSelic: []
    };
  },
  mounted() {
    axios
      .get("/metaSelic")
      .then(
        resposta =>
          (this.historicoSelic = JSON.parse(resposta.data.historicoSelic))
      )
      .catch(error => console.log(error));
  },
  methods: {
    ordenaPorData(items, sortBy, sortDesc) {
      items.sort((a, b) => {
        if (sortBy == "dataFormatada") {
          let partesDataA = a.dataFormatada.split("/");
          let dataA = partesDataA[2] + partesDataA[1] + partesDataA[0];
          let partesDataB = b.dataFormatada.split("/");
          let dataB = partesDataB[2] + partesDataB[1] + partesDataB[0];
          if (!sortDesc) {
            return dataA < dataB ? -1 : 1;
          } else {
            return dataB < dataA ? -1 : 1;
          }
        } else {
          if (!sortDesc) {
            return a.valor < b.valor ? -1 : 1;
          } else {
            return b.valor < a.valor ? -1 : 1;
          }
        }
      });
      return items;
    }
  }
};
</script>

<style lang="scss" scoped></style>
